<template>
  <div id="publication-dashboard--publisher">
    <h3 is="sui-header">
      <i class="newspaper outline icon"></i>
      {{ $t('Publisher information') }}
    </h3>
    <sui-divider />
    <div class="row">
      <h2 class="text-center publisher-name">{{ publisherData.name }}</h2>
    </div>
    <sui-divider />
    <h3 is="sui-header">
      <i class="address book outline icon"></i>
      {{ $t('Contacts') }}
    </h3>
    <sui-divider />
    <div class="row">
      <sui-table celled>
        <sui-table-header>
          <sui-table-row>
            <sui-table-header-cell>{{ $t('Name') }}</sui-table-header-cell>
            <sui-table-header-cell>{{ $t('Email') }}</sui-table-header-cell>
            <sui-table-header-cell>{{ $t('Primary contact') }}</sui-table-header-cell>
          </sui-table-row>
        </sui-table-header>
        <sui-table-body>
          <sui-table-row v-for="item in publisherData.contacts" :key="item.id" >
            <sui-table-cell>{{ item.user.first_name }} {{ item.user.last_name }}</sui-table-cell>
            <sui-table-cell>{{ item.user.email }}</sui-table-cell>
            <sui-table-cell>
              <i class="check icon" v-if="item.is_primary_contact"></i>
              <i class="close icon" v-else></i>
            </sui-table-cell>
          </sui-table-row>
        </sui-table-body>
      </sui-table>
    </div>
    <sui-dimmer :active="loading" inverted>
      <sui-loader />
    </sui-dimmer>
  </div>
</template>

<script>

export default {
  name: 'publisher',
  props: ['dataRequested', 'publisherData'],
  mounted() {
    this.removeLoader();
  },
  updated() {
    this.removeLoader();
  },
  data() {
    return {
      loading: true
    };
  },
  methods: {
    removeLoader() {
      if (this.dataRequested) {
        this.loading = false;
      }
    }
  }
};
</script>
